
export class LOVHeuExtension {
}
